import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

const NavButton = styled(Grid)(({open}) => ({
    borderRadius: open ? '16px 16px 0 0' : '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    color: '#242333',
    margin: '10px 0 0px 0',
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 7%), 0px 1px 1px 0px rgb(0 0 0 / 7%), 0px 1px 3px 0px rgb(0 0 0 / 7%)',
    background: 'white',
    overflow:'hidden',
    transition: 'border-radius 900ms'
}));

export default NavButton;